module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/upload-dc5b71b964f8a077791cdc09af0f83ed.svg";